import type {} from '@mui/lab/themeAugmentation';
import { createTheme } from '@mui/material/styles';

import baseOptions from './baseOptions';
import overrides from './overrides';

const theme = createTheme(baseOptions, overrides);

export default theme;
